
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 rounded-full border-2 border-gray-300 mb-8">
            <span className="text-gray-700 text-sm font-medium uppercase tracking-wide">WHO WE ARE</span>
          </div>
          
          <h2 className="text-6xl font-light text-gray-900 mb-8 leading-relaxed" style={{ fontFamily: 'Playfair Display, serif' }}>
            Revolutionizing Access<br />
            Across New Jersey<br />
            With Smart Technology
          </h2>
        </div>

        {/* FREE highlight banner */}
        <div className="max-w-4xl mx-auto mb-14 bg-teal-50 border-2 border-teal-500 rounded-2xl p-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-price-tag-3-line text-teal-600 text-3xl"></i>
            </div>
            <h3 className="text-3xl font-bold text-teal-700" style={{ fontFamily: 'Playfair Display, serif' }}>
              Completely Free — Zero Cost to You
            </h3>
          </div>
          <p className="text-lg text-teal-800 leading-relaxed">
            Our AI-powered coolers are provided at <strong>absolutely no charge</strong> to your business. No installation fees, no monthly costs, no maintenance bills — ever. We handle everything so you can focus on what matters most.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 text-lg text-gray-600 leading-relaxed">
            <p>
              Simple Amenities is transforming the way businesses provide convenient access to products and services. Our AI-powered vending machines combine cutting-edge technology with unattended operation, delivering 24/7 availability to your customers — at <strong>no cost to you</strong>.
            </p>
            <p>
              Serving businesses across New Jersey, we handle all stocking, servicing, and maintenance ourselves. You simply enjoy the benefit of a fully stocked, always-running smart cooler in your space — completely free of charge.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid md:grid-cols-4 gap-6 mt-16">
            <div className="bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-gift-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">100% Free</h3>
              <p className="text-gray-600 leading-relaxed">
                No cost to you — ever. Installation, equipment, and service are all completely free
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-tools-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Maintenance-Free</h3>
              <p className="text-gray-600 leading-relaxed">
                We take care of all repairs and upkeep. You never have to lift a finger
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-refresh-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Regularly Stocked</h3>
              <p className="text-gray-600 leading-relaxed">
                We restock your machine on a regular schedule so it&apos;s always full and ready
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">24/7 Available</h3>
              <p className="text-gray-600 leading-relaxed">
                Unattended operation means your customers have access anytime, day or night
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
